<template lang="pug">
v-layout(column)
  //- v-flex
    v-btn(@click="reha" block color="primary" x-large) FÜR REHASPORT HIER KLICKEN
  .embed(v-for="kurs in kurse")
    <iframe width="560" height="315" :src="`https://www.youtube-nocookie.com/embed/${kurs}?modestbranding=1&rel=0&iv_load_policy=3`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</template>

<script>
export default {
  data: () => ({
    kurse: [],
  }),
  methods: {
    reha() {
      window.open("https://www.youtube.com/channel/UCcAHmqwheLKtYq2GXMB3FKQ")
    },
  },
  mounted() {
    const self = this
    self.socket.emit("getKurse", {}, kurse => {
      self.kurse = kurse
    })
  },
}
</script>

<style lang="stylus">
.embed
  display: flex
  justify-content: center
  align-items: center
  margin: 14px 0

  iframe
    border-radius: 5px
</style>